import React, { useState, useEffect } from "react";
// import PopupBanner from "../../commons/assets/vintage2023.png";
import { Modal, Close } from "./StyledWelcomeModal";
import './styles.scss';
import {settingService} from '../../services/setting'

export default function WelcomeModal(props) {
  const [loadModal, setLoadModal] = useState(false);
  const [popup, setPopup] = useState(null);

  useEffect(() => {
      settingService.get().then(data => {
          if (data.data.pop_up){
              setPopup(data.data.pop_up);
              setLoadModal(true);
              // console.log('Actualizando popup, ', loadModal, popup);
          }
      });
  }, []);

  return (
    loadModal && popup ? (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 99998,
        background: 'rgba(0,0,0,0.4)',
        pointerEvents: 'auto',
      }}>
        <Modal size="alpha" onHide={() => setLoadModal(false)}>
          <Close size={20} onClick={() => setLoadModal(false)} />
            <a
              href={`${window.location.origin}/app`}
              style={{ display: 'inline-block' }}
            >
            <img className="modal-img" src={popup} alt="Popup banner" style={{ cursor: 'pointer' }} />
          </a>
        </Modal>
      </div>
    ) : (<div></div>)
  );
}
